export const manageMyBookingAction = {
  INITIALIZE: "INITIALIZE",
  SAVEDATA:"SAVEDATA",
};